import type { FunctionComponent } from 'react'

import { FlowPage } from '@monthio/design-system'
import { LoadingScreen, trackingService } from '@monthio/react-components'
import { BankSessionStatus } from '#modules/Bank/Redux/reducers/consumerDataPullSessionReducers/bankSessionReducer'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import type { RootState } from '../../Redux/reducers'

import { routeCodes } from '../../Bank.types'

export const ReopenSession: FunctionComponent<{ children?: never }> = () => {
	const { push } = useHistory()
	const reopeningSessionSuccessful = useSelector<RootState>(
		(state) => state?.consumerSessionData?.reopeningSessionSuccessful,
	)
	const bankSessionsStatus = useSelector<RootState>(
		(state) => state?.bankSessions.status,
	)
	const sessionClosed = useSelector<RootState>(
		(state) => state?.closeConsumerDataPullSession.closed,
	)

	useEffect(() => {
		if (
			reopeningSessionSuccessful &&
			!sessionClosed &&
			bankSessionsStatus === BankSessionStatus.FETCH_SUCCESS
		) {
			trackingService.trackTechnicalEvent('reopeningSessionComplete')
			push(routeCodes.bankSessionOverviewPage)
		}
	}, [reopeningSessionSuccessful, push, sessionClosed, bankSessionsStatus])

	return (
		<FlowPage>
			<FlowPage.Content $isCentered>
				<LoadingScreen />
			</FlowPage.Content>
		</FlowPage>
	)
}
